import React, { useRef } from "react";
import { Album } from "./types";
import { usePopupClickOutside } from "../../../hooks/usePopupClickOutside";

type SubscriptionOptionsModalType = {
  selectedAlbum: Album | null;
  onClose: () => void;
};

const SubscriptionOptionsModal = ({
  selectedAlbum,
  onClose
}: SubscriptionOptionsModalType) => {
  const popupRef = useRef<HTMLDivElement>(null);
  usePopupClickOutside(popupRef, () => onClose());

  const ModalBody = () => {
    // If the user can't manage or create subscription, show contact message
    const canTakeAction = selectedAlbum?.hasFreeSharingSubscription
      ? selectedAlbum?.canManageFreeSharingSubscription
      : selectedAlbum?.canCreateFreeSharingSubscription;

    if (!canTakeAction) {
      return (
        <div className="account-settings-section contact-organizer">
          <div className="owner-settings-content">
            Please contact the event organizer.
          </div>
        </div>
      );
    }

    // User has subscription but needs to reactivate
    if (selectedAlbum?.hasFreeSharingSubscription) {
      return (
        <>
          <div className="modal-body">
            <div className="modal-info">
              Your subscription has been cancelled. To continue uploading
              photos, please reactivate your plan.
            </div>
          </div>
          <div>
            <a
              href={selectedAlbum?.manageSubscriptionPath}
              className="geo-btn geo-btn--secondary geo-btn--caps subscription-cta"
            >
              Reactivate Subscription
            </a>
          </div>
        </>
      );
    }

    // User needs to create subscription
    return (
      <>
        <div className="modal-body">
          <div className="modal-info">
            In order to upload photos to free events, you need to subscribe.
          </div>
        </div>
        <div>
          <a
            href={selectedAlbum?.createSubscriptionPath}
            className="geo-btn geo-btn--secondary geo-btn--caps subscription-cta"
          >
            Subscribe Now
          </a>
        </div>
      </>
    );
  };

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--show geo-modal--small subscription-options-modal"
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content" ref={popupRef}>
          <div className="modal-header">
            &nbsp;
            <button
              type="button"
              className="close confirm-close"
              onClick={onClose}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="geo-modal__header">
            <div className="p-header">Action Required</div>
            <span className="s-header">
              There’s an issue with your subscription
            </span>
          </div>
          <ModalBody />
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default SubscriptionOptionsModal;
